module.exports = __webpack_public_path__ + "static/media/0.d63c4fdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hats/0.png
// module id = 1290
// module chunks = 0